const strings = {
  NEW_LAUNDRY_TIME: 'Skapa en tvättid',
  NEW_LAUNDRY_TIME_INFORMATION:
    'Ställ in en start -och sluttid för att skapa en tvättid.',
  MANDATORY_FIELD: 'Fältet är oblikatoriskt',
  LAUNDRY_TIME_CREATED: 'Tvättiden har skapats',
  INTERNAL_ERROR: 'Ett oväntat fel har uppstått, var god försök igen.'
}

export default strings



// WEBPACK FOOTER //
// ./src/components/containers/NewLaundryTimeModal/strings.js